import { DateTime } from "luxon";

export function AsOf({ date }) {
    return date ? (
        <span className="as-of">
            as of {DateTime.fromISO(date, { zone: "utc" }).toLocaleString(DateTime.DATE_FULL)}
        </span>
    ) : null;
}
